// src/pages/NotFound.js
import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import styled from 'styled-components';
import { fadeIn } from '../styles/animations';

const NotFoundWrapper = styled.div`
  padding-top: 80px; // Pour compenser la hauteur du header fixe
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: calc(100vh - 80px);
  background-color: ${props => props.theme.colors.light};
`;

const NotFoundContainer = styled.div`
  max-width: 600px;
  text-align: center;
  padding: ${props => props.theme.spacing.xl};
  animation: ${fadeIn} 0.8s ease-out forwards;
`;

const NotFoundTitle = styled.h1`
  font-size: ${props => props.theme.fontSizes.xxxl};
  margin-bottom: ${props => props.theme.spacing.md};
  color: ${props => props.theme.colors.primary};
  
  span {
    display: block;
    font-size: 5rem;
    line-height: 1;
    color: ${props => props.theme.colors.primary};
    margin-bottom: ${props => props.theme.spacing.md};
  }
`;

const NotFoundText = styled.p`
  font-size: ${props => props.theme.fontSizes.large};
  margin-bottom: ${props => props.theme.spacing.lg};
  color: ${props => props.theme.colors.textMain};
`;

const ButtonContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: ${props => props.theme.spacing.md};
  
  @media (max-width: ${props => props.theme.breakpoints.sm}) {
    flex-direction: column;
  }
`;

const Button = styled(Link)`
  display: inline-block;
  padding: 0.75rem 1.5rem;
  border-radius: ${props => props.theme.borderRadius.medium};
  font-weight: 600;
  text-decoration: none;
  transition: all ${props => props.theme.transitions.fast};
  
  &.primary {
    background-color: ${props => props.theme.colors.primary};
    color: ${props => props.theme.colors.light};
    
    &:hover {
      background-color: ${props => props.theme.colors.primaryDark};
    }
  }
  
  &.secondary {
    background-color: transparent;
    color: ${props => props.theme.colors.primary};
    border: 2px solid ${props => props.theme.colors.primary};
    
    &:hover {
      background-color: ${props => props.theme.colors.primary}10;
    }
  }
`;

const NotFound = () => {
    return (
        <NotFoundWrapper>
            <Helmet>
                <title>Page Non Trouvée - Decko | Créateur de vos parquets de jardin</title>
                <meta name="description" content="La page que vous recherchez n'existe pas ou a été déplacée." />
            </Helmet>

            <NotFoundContainer>
                <NotFoundTitle>
                    <span>404</span>
                    Page Non Trouvée
                </NotFoundTitle>
                <NotFoundText>
                    Oups ! La page que vous recherchez n'existe pas ou a été déplacée.
                    Vous pouvez revenir à l'accueil ou consulter nos réalisations.
                </NotFoundText>
                <ButtonContainer>
                    <Button to="/" className="primary">
                        Retour à l'accueil
                    </Button>
                    <Button to="/realisations" className="secondary">
                        Voir nos réalisations
                    </Button>
                </ButtonContainer>
            </NotFoundContainer>
        </NotFoundWrapper>
    );
};

export default NotFound;